import type { FormikProps } from 'formik';
import * as React from 'react';
import { SIGNUP_FIELDS } from '../../constants/signUp.constants';
import type { UserSignUp } from '../../interfaces/auth.interface';
import { SignupField } from './SignupField';

interface SignUpCoreFieldsGridProps {
  formikProps: FormikProps<UserSignUp>;
  disabled: string;
}

/**
 * Render core fields for sign up form.
 *
 * @param {SignUpCoreFieldsGridProps} props - The props object containing formikProps and disabled properties.
 * @returns {React.ReactNode} - The rendered core fields.
 */
export function SignUpCoreFieldsGrid(props: SignUpCoreFieldsGridProps): any {
  const { formikProps, disabled } = props;
  const { FIRST_NAME, LAST_NAME, USERNAME, EMAIL } = SIGNUP_FIELDS;

  const CORE_FIELDS = [FIRST_NAME, LAST_NAME, USERNAME, EMAIL];

  return CORE_FIELDS.map((field) => {
    return (
      <SignupField
        key={field}
        disabled={disabled}
        id={field}
        {...formikProps}
        placeholder={field}
        type="text"
      />
    );
  });
}
